const state = {
    isLoaded: false
};

const getters = {
    isLoaded(state) {
        return state.isLoaded;
    }
};

const actions = {
    isLoaded(context , user){
        context.commit('isLoaded', user)
    }
};

const mutations = {
    isLoaded(state, value) {
        state.isLoaded = !!value;
    },
};

export default {
    namespaced : true,
    state,
    actions,
    mutations,
    getters
};
